var url={img:''}
if(window.location.hostname=='192.168.1.25'){
    url.img='http://192.168.1.25:8160'
}
else if(window.location.hostname=='project.urasr.com'){
    url.img='http://project.urasr.com'
}
else{
    url.img='http://192.168.1.25:8160'
}
export default url



// WEBPACK FOOTER //
// ./src/api/url.js